import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';

enum FileTypeEnum {
  PDF = 'PDF',
  JPG = 'JPG',
  PNG = 'PNG',
  JPEG = 'JPEG'
}

@Injectable()
export class FileService {
  constructor(
    // private _notificationService: NotificationsService
  ) {}

  public isValidImage(type: string): boolean {
    if (type !== 'image/jpeg' && type !== 'image/jpg' && type !== 'image/png') {
      // this._notificationService.showNotification({
      //   CloseOther: false,
      //   Message: 'La imagen que intenta subir no esta permitida.',
      //   ShowCloseButton: true,
      //   Title: 'Error en subida de archivo',
      //   Type: TypeNotification.error
      // });
      return false;
    }
    return true;
  }

  public isValidPdf(type: string): boolean {
    if (type !== 'application/pdf') {
      // this._notificationService.showNotification({
      //   CloseOther: false,
      //   Message: 'El archivo que intenta subir no esta permitido.',
      //   ShowCloseButton: true,
      //   Title: 'Error en subida de archivo',
      //   Type: TypeNotification.error
      // });
      return false;
    }
    return true;
  }

  public isValidImageOrPdf(type: string): boolean {
    if (
      type !== 'application/pdf' &&
      type !== 'image/jpeg' &&
      type !== 'image/jpg' &&
      type !== 'image/png'
    ) {
      // this._notificationService.showNotification({
      //   CloseOther: false,
      //   Message: 'El archivo que intenta subir no esta permitido.',
      //   ShowCloseButton: true,
      //   Title: 'Error en subida de archivo',
      //   Type: TypeNotification.error
      // });
      return false;
    }
    return true;
  }

  public download(fileBase64: string, fileName: string) {
    let fileType: FileTypeEnum;
    fileType = this.getFileBase64Type(fileBase64);
    let file: string;

    switch (fileType) {
      case FileTypeEnum.PDF: {
        file = fileBase64.replace('data:application/pdf;base64,', '');
        break;
      }
      case FileTypeEnum.JPG: {
        file = fileBase64.replace('data:image/jpg;base64,', '');
        break;
      }
      case FileTypeEnum.PNG: {
        file = fileBase64.replace('data:image/png;base64,', '');
        break;
      }
      case FileTypeEnum.JPEG: {
        file = fileBase64.replace('data:image/jpeg;base64,', '');
        break;
      }
      default: {
        file = fileBase64;
        break;
      }
    }

    let binary = atob(file.replace(/\s/g, ''));
    let len = binary.length;
    let buffer = new ArrayBuffer(len);
    let view = new Uint8Array(buffer);
    for (let i = 0; i < len; i++) {
      view[i] = binary.charCodeAt(i);
    }

    switch (fileType) {
      case FileTypeEnum.PDF: {
        let blob = new Blob([view], { type: 'application/pdf' });
        saveAs(blob, fileName);
        break;
      }
      case FileTypeEnum.JPG: {
        let blob = new Blob([view], { type: 'image/jpg' });
        saveAs(blob, fileName);
        break;
      }
      case FileTypeEnum.PNG: {
        let blob = new Blob([view], { type: 'image/png' });
        saveAs(blob, fileName);
        break;
      }
      case FileTypeEnum.JPEG: {
        let blob = new Blob([view], { type: 'image/jpeg' });
        saveAs(blob, fileName);
        break;
      }
      default: {
        break;
      }
    }
  }

  private getFileBase64Type(fileBase64: string): FileTypeEnum {
    if (fileBase64.indexOf('data:application/pdf') >= 0) {
      return FileTypeEnum.PDF;
    }

    if (fileBase64.indexOf('image/jpg') >= 0) {
      return FileTypeEnum.JPG;
    }

    if (fileBase64.indexOf('image/png') >= 0) {
      return FileTypeEnum.PNG;
    }

    if (fileBase64.indexOf('image/jpeg') >= 0) {
      return FileTypeEnum.JPEG;
    }

    return null;
  }
}
